import React from 'react';
import Title from '../../Title/Title';
import CommunityCard from '../CommunityCard/CommunityCard';
import Icon from '../../Icon/Icon';
import './Community.scss';
import icnDiscord from '../../../images/icn-discord.svg';
import icnGithub from '../../../images/icn-github.svg';
import icnTwitter from '../../../images/icn-twitter.svg';

export default function Community() {
  return (
    <section className="community">
      <div className="community__line"></div>
      <Title size="m" title="Meet our community" />
      <ul className="community__cardlist">
        <CommunityCard title="200+" description="Open Source Contributors" />
        <CommunityCard title="5000+" description="Community members" />
        <CommunityCard title="500+" description="Companies" />
        <CommunityCard title="13000+" description="Github Stars" />
      </ul>
      <div className="community__container">
        <p className="community__text">Join the community:</p>
        <ul className="community__iconlist">
          <li className="community__iconlist-item">
            <Icon
              icon={icnDiscord}
              link="https://dvc.org/chat"
              linkDescription="Go to Discord"
              widthPixelSizes={[32, 24, 32]}
            />
          </li>
          <li className="community__iconlist-item">
            <Icon
              icon={icnGithub}
              link="https://github.com/iterative"
              linkDescription="Go to Github"
              widthPixelSizes={[32, 24, 32]}
            />
          </li>
          <li className="community__iconlist-item">
            <Icon
              icon={icnTwitter}
              link="https://twitter.com/DVCorg"
              linkDescription="Go to Twitter"
              widthPixelSizes={[32, 24, 32]}
            />
          </li>
        </ul>
      </div>
    </section>
  );
}
